import { getPrinter } from 'shared/printerManager';

export const sendPrintJob = async (prn) => {
  return new Promise((resolve, reject) => {
    prn.startMonitor();
    prn.send();
    prn.onreceive = (res) => {
      if (res.success) {
        resolve();
      } else {
        reject();
      }
    };
    prn.stopMonitor();
  });
};

export const usePrintCashReport = () => {
  const printReport = async ({ cashDrawerReport, setIsPrinting }) => {
    if (setIsPrinting) setIsPrinting(true);

    try {
      const prn = getPrinter(); // Replace with your actual printer initialization

      // Process each ticket in the batch
      try {
        // Get current date and time
        const now = new Date();
        const date = now.toLocaleDateString('en-US');
        const time = now.toLocaleTimeString('en-US', {
          hour: 'numeric',
          minute: '2-digit',
          hour12: true,
        });

        prn.addTextAlign(prn.ALIGN_CENTER);
        prn.addTextSmooth(true);

        // Header section
        prn.addTextStyle(false, false, true, prn.COLOR_1);
        prn.addTextFont(prn.FONT_A);

        prn.addTextSize(1, 1);
        prn.addTextFont(prn.FONT_A);
        prn.addTextStyle(false, false, false, prn.COLOR_1);
        prn.addText('===============================================\n');
        prn.addTextAlign(prn.ALIGN_CENTER);
        prn.addTextStyle(false, false, true, prn.COLOR_1);
        prn.addTextSize(2, 2);
        prn.addText('MY BOX OFFICE REPORT\n');
        prn.addTextSize(1, 1);
        prn.addTextFont(prn.FONT_A);
        prn.addTextStyle(false, false, false, prn.COLOR_1);
        prn.addText('===============================================\n');
        prn.addTextAlign(prn.ALIGN_LEFT);
        prn.addFeedLine(1);

        // Reset formatting for body text
        prn.addTextSize(1, 1);
        prn.addTextStyle(false, false, false, prn.COLOR_1);
        prn.addText(`Cashier: ${cashDrawerReport.user.formatted_name}\n`);
        prn.addText(`Date: ${date}\n`);
        prn.addText(`Time: ${time}\n`);
        prn.addFeedLine(1);

        // Payment Summary Section
        prn.addTextAlign(prn.ALIGN_CENTER);
        prn.addText('================================\n');
        prn.addText('PAYMENT SUMMARY\n');
        prn.addText('================================\n');
        prn.addTextAlign(prn.ALIGN_LEFT);
        prn.addFeedLine(1);
        prn.addText(`Cash Payments:           ${cashDrawerReport.cash}\n`);
        prn.addText(`Card Payments:             ${cashDrawerReport.card}\n`);
        prn.addText(
          `Total Transactions:           ${cashDrawerReport.num_transactions}\n`
        );
        prn.addFeedLine(1);

        // Ticket Sales Section
        prn.addTextAlign(prn.ALIGN_CENTER);
        prn.addText('================================\n');
        prn.addText('TICKET SALES\n');
        prn.addText('================================\n');
        prn.addTextAlign(prn.ALIGN_LEFT);
        prn.addFeedLine(1);

        for (const ticket of cashDrawerReport.ticket_breakdown_data) {
          // Individual ticket items
          prn.addText(`${ticket.name}\n`);
          prn.addText(
            `  ${ticket.qty} x ${ticket.price}              ${ticket.total}\n`
          );
          prn.addFeedLine(1);
        }

        // Summary totals
        prn.addText('--------------------------------\n');
        prn.addTextStyle(false, false, true, prn.COLOR_1); // Bold for totals
        prn.addText(
          `TOTAL TICKETS SOLD:          ${cashDrawerReport.num_tickets}\n`
        );
        prn.addText(
          `TOTAL REVENUE:           ${cashDrawerReport.total_revenue}\n`
        );
        prn.addTextStyle(false, false, false, prn.COLOR_1); // Back to normal
        prn.addFeedLine(1);

        // Footer
        prn.addTextAlign(prn.ALIGN_CENTER);
        prn.addText('================================\n');
        prn.addText('End of Report - Thank You!\n');
        prn.addText('================================\n');

        prn.addCut(prn.CUT_FEED);
      } catch (error) {
        console.error(`Error:`, error);
      }

      // Send this batch to printer
      try {
        await sendPrintJob(prn);
      } catch (error) {
        console.error(`Error printing report`, error);
        alert(`Error printing report`);
        // Continue with next batch instead of stopping completely
      }
    } catch (error) {
      console.error('Error in printReport:', error);
      alert(`Error in print process: ${error}`);
    } finally {
      if (setIsPrinting) setIsPrinting(false);
    }
  };

  return { printReport };
};
